interface IPropyCookieValue {
  type: string;
  cookieValue: string;
}
const propyCookieValue = (state : string = '{}', action: IPropyCookieValue) => {
  switch (action.type) {
      case 'SET_PROPY_COOKIE_VALUE':
          return action.cookieValue
      default:
          return state
  }
}

export default propyCookieValue;